import { createFileRoute } from '@tanstack/react-router';
import { TERMS_URL } from '../lib/legal';

/** The terms are on the public site — see `lib/legal.ts`. `replace`, so Back skips this hop. */
export const Route = createFileRoute('/terms')({
  beforeLoad: () => {
    window.location.replace(TERMS_URL);
  },
  component: () => null,
});
